import { StyledProps } from '@front10';
import React from 'react';
import Box from '../../../elements/Box';
import OperationDay, { BusSchedule } from './OperationDay';
import Title from './Title';

export interface OperationDaySpec {
  label: string;
  hours: BusSchedule[];
}

interface Props {
  showTitle?: boolean;
  showOperationDays?: boolean;
  operationDays?: OperationDaySpec[];
  titleStyles?: StyledProps;
  titleKey: string;
  operationDaysStyles?: React.ComponentPropsWithoutRef<typeof OperationDay>;
}

function HoursOperationType({
  showTitle = true,
  showOperationDays = true,
  titleStyles = {},
  operationDays = [],
  operationDaysStyles = {},
  titleKey,
  ...props
}: StyledProps<Props>) {
  return (
    <Box className="station-item-hours-operation-type" marginHeight="2" {...props}>
      {showTitle && (
        <Title
          showLeftIcon={false}
          showRightIcon={false}
          marginBottom="1"
          labelKey={titleKey}
          {...titleStyles}
        />
      )}
      {showOperationDays &&
        operationDays.map((item) => (
          <OperationDay
            key={item.label}
            day={item.label}
            schedules={item.hours}
            {...operationDaysStyles}
          />
        ))}
    </Box>
  );
}

HoursOperationType.componentName = 'HoursOperationType';

export default HoursOperationType;
